import { MutationTree } from "vuex";
import { RolesState } from ".";
import { Role } from "../../models/role.model";

export const RolesMutationTypes = {
  GetRoles: "GET_ROLES"
};

export const mutations: MutationTree<RolesState> = {
  [RolesMutationTypes.GetRoles](state: RolesState, payload: Role[]) {
    state.roles = payload;
  }
};
